import { useMutation } from "urql";

import { CreateLateFeeDocument } from "../../../../graphql/generated.ts";

export function useCreateLateFee() {
  return useMutation(CreateLateFeeDocument);
}
